var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.09 0H6a.91.91 0 00-.91.91v5.14h1V1H23v17h-5v1h5.14a.91.91 0 00.86-1V.91a.91.91 0 00-.91-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5.05H.91A.91.91 0 000 6v17.09a.91.91 0 00.91.91H18a.91.91 0 00.91-.91V6a.91.91 0 00-.91-.95zM18 23H1V6.05h17z"
  })))));
}
export default SvgDuplicateCards;